export default __webpack_public_path__ + "static/media/bg.2a2a056b.png";